"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/TableMaker/constants");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var RemoveVendor_1 = __importDefault(require("./CellComponents/RemoveVendor"));
var SetupPlans_1 = __importDefault(require("./CellComponents/SetupPlans"));
var UploadCSVButton_1 = __importDefault(require("./CellComponents/UploadCSVButton"));
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD;
var tableConf = {
    headersMap: {
        name: 'Vendor',
        accountingProvider: 'Accounting',
        importMethods: '',
    },
    config: {
        noFooter: true,
        selector: populatedDerived_1.selectExtendedRechargedCompanyVendors,
        defaultSort: { key: 'name', order: 1 },
    },
    extractors: {
        name: function (item) { var _a; return (_a = item.rechVendor) === null || _a === void 0 ? void 0 : _a.name; },
        importMethod: function (item) { var _a; return (_a = item.rechVendor) === null || _a === void 0 ? void 0 : _a.mainImportMethod; },
        firstImport: function (item) { var _a; return (_a = item.firstImport) === null || _a === void 0 ? void 0 : _a.toDate(); },
        lastImport: function (item) { var _a; return (_a = item.lastImport) === null || _a === void 0 ? void 0 : _a.toDate(); },
    },
    cells: [
        { field: 'name', cell: { width: LG }, avatar: { size: 'xxs' }, truncate: {} },
        { field: 'importMethod', cell: { width: MD }, truncate: {} },
        { field: 'firstImport', cell: { width: MD }, renderField: end2end_1.getDateNice },
        { field: 'lastImport', cell: { width: MD }, renderField: end2end_1.getDateNice },
        { field: 'discountSplit', cell: { width: MD }, renderField: function (v) { return v ? (0, end2end_1.formatPercentage)(v) : 'N/A'; } },
        { key: 'setupPlans', cell: { width: LG }, renderComponent: SetupPlans_1.default },
        { key: 'uploadCsv', cell: { width: LG }, renderComponent: UploadCSVButton_1.default },
        { key: 'remove', cell: { width: MD }, renderComponent: RemoveVendor_1.default },
    ],
};
exports.default = tableConf;
